@file:Suppress("UnsafeCastFromDynamic")

package org.example.project.service

import kotlinx.browser.window

private fun currentWebpackBuildHash(): String {
    val value = js(
        """
        (function() {
            if (typeof __webpack_hash__ !== 'undefined' && __webpack_hash__) return __webpack_hash__;
            return "";
        })()
        """
    )
    return (value as? String).orEmpty()
}

fun shouldForceLogoutAfterBuildChange(scope: String): Boolean {
    val currentHash = currentWebpackBuildHash()
    if (currentHash.isBlank()) return false

    val storageKey = "__lumatica_build_hash__$scope"
    val previousHash = window.localStorage.getItem(storageKey).orEmpty()
    window.localStorage.setItem(storageKey, currentHash)

    if (previousHash.isBlank()) return false
    if (previousHash == currentHash) return false
    // Ein Buildwechsel darf die serverseitige Sitzung niemals beenden. Der Hash
    // wird nur gespeichert, damit der Wiederanlauf einen Versionswechsel erkennt.
    // Session-Cookie und Session-Kontext bleiben erhalten und restoreSession()
    // stellt den Benutzer nach dem kontrollierten Reload wieder her.
    return false
}
